import React, { useState } from "react";
import { useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import DropdownButton from "../ui-components/drop_button";


const AdminAutoTaskItem =({listOfAutoTask, loading})=>{
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(listOfAutoTask.length);

    useEffect(()=>{
        console.log("Data In Item: ",listOfAutoTask)
    },[listOfAutoTask])

    return (
        <main className="dashboard-main">
          <div className="admin-auto-task-top-title-container">
            <div className="admin-auto-task-top-title-left">
              <h2 className="admin-title">Automatic Tasks</h2>
            </div>
            <div className="admin-auto-task-top-title-right">
              <DropdownButton/>
            </div>
          </div>
    
          <ul className="task-list-auto-task">
            {listOfAutoTask && listOfAutoTask.length > 0 ? (
              listOfAutoTask.map((task, index) => (
                <li
                  key={task.id || index}
                  className={"task-item-auto-task"}
                >
                  <div className="admin-auto-task-top-item-top-container">
                    <div className="admin-auto-task-top-item-left">
                      <p>
                      {task.code_discript == "Successful"?<FaCheckCircle/>:null} 
                      {task.code_discript == "Successful"?" Done: ":null}
                      {task.date_completed}</p>
                    </div>
                    <div className="admin-auto-task-top-item-right">
                      # {task.id}
                    </div>
                  </div>
                  <div className="admin-auto-task-top-item-bottom-container">
                    <p className="admin-auto-task-item-bottom-p">Task Name: {task.name}</p>
                    <p className="admin-auto-task-item-bottom-p">Task Status: <strong>{task.code_discript}</strong></p>
                  </div>
                </li>
              ))
            ) : (
              <p>No tasks found.</p>
            )}
          </ul>
        </main>
      );
}

export default AdminAutoTaskItem;
